export type DealStage = 'prospecting' | 'qualified' | 'proposal' | 'negotiation' | 'won' | 'lost'

export interface CustomerBrief {
  id: string
  first_name: string
  last_name: string
}

// Optional read-model brief of the boat a deal is tied to (e.g. a
// consignment sale). Present only when the deal has a boat_id. Type lets the
// add-on picker filter to what fits the hull; Price is the listing price the
// base value defaults to.
export interface DealBoatBrief {
  id: string
  make: string
  model: string
  year: number
  type: string
  price: number
}

export interface Deal {
  id: string
  title: string
  value: number // rollup: base_value + add-on line totals
  base_value: number // hand-entered price of the boat/deal itself
  addons_total: number // the add-on portion alone
  stage: DealStage
  owner: string
  customer_id: string
  boat_id?: string | null
  customer: CustomerBrief
  boat?: DealBoatBrief | null
  expected_close?: string
  created_at: string
  updated_at: string
}

export const DEAL_STAGES: DealStage[] = [
  'prospecting',
  'qualified',
  'proposal',
  'negotiation',
  'won',
  'lost',
]

export const OPEN_STAGES: DealStage[] = ['prospecting', 'qualified', 'proposal', 'negotiation']

export const STAGE_LABELS: Record<DealStage, string> = {
  prospecting: 'Prospecting',
  qualified: 'Qualified',
  proposal: 'Proposal',
  negotiation: 'Negotiation',
  won: 'Won',
  lost: 'Lost',
}

export const STAGE_DOT: Record<DealStage, string> = {
  prospecting: 'bg-info',
  qualified: 'bg-chart-3',
  proposal: 'bg-chart-4',
  negotiation: 'bg-warning',
  won: 'bg-success',
  lost: 'bg-destructive',
}

export const STAGE_COLUMN: Record<DealStage, string> = {
  prospecting: 'bg-info',
  qualified: 'bg-chart-3',
  proposal: 'bg-chart-4',
  negotiation: 'bg-warning',
  won: 'bg-success',
  lost: 'bg-destructive',
}
